const dateFmt = new Intl.DateTimeFormat("pl-PL", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
const monthFmt = new Intl.DateTimeFormat("pl-PL", { month: "long", year: "numeric", timeZone: "UTC" });

/** "2026-10-16" -> "16 października 2026" */
export function longDate(iso: string): string {
  return dateFmt.format(new Date(`${iso}T00:00:00Z`));
}

export function year(iso: string): number {
  return Number(iso.slice(0, 4));
}

/** "1998–2004", or just "1998" when it is one year. */
export function yearRange(first: string, last: string): string {
  const a = year(first), b = year(last);
  return a === b ? String(a) : `${a}–${b}`;
}

/** Polish plural: plural(5, "notowanie", "notowania", "notowań") */
export function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10, mod100 = n % 100;
  if (n === 1) return one;
  if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return few;
  return many;
}

export const appearances = (n: number) => `${n} ${plural(n, "notowanie", "notowania", "notowań")}`;

export function artistNames(artists: { name: string }[], fallback: string): string {
  return artists.length ? artists.map((a) => a.name).join(", ") : fallback;
}

export function monthYear(iso: string): string {
  return monthFmt.format(new Date(`${iso}T00:00:00Z`));
}

/** Change in position vs. the previous chart, when the source tells us. */
export function movement(position: number, prev: number | null, weeks: number | null):
  { kind: "new" | "up" | "down" | "same"; by: number } | null {
  if (prev === null) return weeks === 1 ? { kind: "new", by: 0 } : null;
  const diff = prev - position;
  return diff > 0 ? { kind: "up", by: diff } : diff < 0 ? { kind: "down", by: -diff } : { kind: "same", by: 0 };
}

export function listenUrl(artists: { name: string }[], title: string, credit: string): string {
  return `https://www.youtube.com/results?search_query=${encodeURIComponent(`${artistNames(artists, credit)} ${title}`)}`;
}
